<section class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2 login-form-custom-style">
    <div class="card mb-0">
      <div class="card-body">
        <a class="brand-logo">
          <img
            src="../../../../../assets/images/pages/logo_white.png"
            alt="brand-logo"
            height="80"
          />
        </a>

        <h4 class="card-title mb-1">Login to Kingsschool 👋 !</h4>
        <p class="card-text mb-2">
          Continue from where you left by filling in the form below.
        </p>

        <form
          class="auth-login-form mt-2"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="form-group">
            <label for="login-email" class="form-label">Email</label>
            <input
              type="email"
              formControlName="email"
              class="form-control"
              placeholder="john@example.com"
              aria-describedby="login-email"
              autocomplete="false"
              tabindex="1"
              id="login-email"
              autofocus
              [ngClass]="{ 'is-invalid': f.email.errors && f.email.dirty }"
            />
            <div *ngIf="f.email.errors && f.email.dirty" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">
                Email must be a valid email address
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label for="login-password">Password</label>
              <a routerLink="/auth/forgot-password">
                <small>Forgot Password?</small>
              </a>
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                autocomplete="false"
                class="form-control form-control-merge"
                tabindex="2"
                placeholder="·········"
                id="login-password"
                aria-describedby="login-password"
                [ngClass]="{
                  'is-invalid error': f.password.errors && f.password.dirty
                }"
              />

              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
              </div>
            </div>
            <div
              *ngIf="f.password.errors && f.password.dirty"
              class="invalid-feedback"
              [ngClass]="{ 'd-block': f.password.errors }"
            >
              <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                id="remember-me"
                tabindex="3"
              />
              <label class="custom-control-label" for="remember-me">
                Remember Me
              </label>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-block flex items-center justify-center gap-3"
            tabindex="4"
            [disabled]="(loaderService._observer | async)?.isLoading || loginForm.invalid"
            rippleEffect
          >
            <app-loader></app-loader>

            <span>{{
              (loaderService._observer | async)?.isLoading
                ? "Processing"
                : "Sign in"
            }}</span>
          </button>
        </form>

        <!-- <p class="text-center mt-2">
          <span>New on our platform?</span>
          <a routerLink="/auth/register">
            <span>&nbsp;Create an account</span>
          </a>
        </p> -->
      </div>
    </div>
  </div>
</section>
